// eslint-disable-next-line no-restricted-imports
import {
  LegalClientKnowledgeAndExperienceDto_Input,
  Query_LegalClientController_GetList_AllOf_1_List_Items_KnowledgeAndExperience_QualifiedOfficerForInvestmentDecision_EducationLevel as EducationLevelApi,
  Query_LegalClientController_GetList_AllOf_1_List_Items_KnowledgeAndExperience_FinancialInstruments_Items as FinancialInstrumentsApi,
} from 'api/generated/graphql';
import { EducationLevelType } from 'api/types/entity';
import { LegalClientKnowledgeAndExperienceParam } from 'api/types/params';

const educationLevelMap: Record<EducationLevelType, EducationLevelApi> = {
  [EducationLevelType.MasterOrPhdInFinance]:
    EducationLevelApi.MasterOrPhdInFinance,
  [EducationLevelType.BachelorInFinance]: EducationLevelApi.BachelorInFinance,
  [EducationLevelType.BachelorInOtherFields]:
    EducationLevelApi.BachelorInOtherFields,
  [EducationLevelType.SecondaryEducationInFinance]:
    EducationLevelApi.SecondaryEducationInFinance,
  [EducationLevelType.ProfessionalCertificateInFinance]:
    EducationLevelApi.ProfessionalCertificateInFinance,
  [EducationLevelType.PrimaryEducation]: EducationLevelApi.PrimaryEducation,
};

export const parseLegalClientKnowledgeAndExperienceParam = (
  data: LegalClientKnowledgeAndExperienceParam
): LegalClientKnowledgeAndExperienceDto_Input => ({
  hasQualifiedOfficersForInvestmentDecisions:
    data.hasQualifiedOfficersForInvestmentDecisions,
  qualifiedOfficerForInvestmentDecision:
    data.hasQualifiedOfficersForInvestmentDecisions
      ? {
          educationLevel: educationLevelMap[data.educationLevel!],
          heldFinancialPositionInLast5Years:
            data.heldFinancialPositionInLast5Years!,
        }
      : null,

  financialInstruments:
    data.financialInstruments?.map((v) => FinancialInstrumentsApi[v]) ?? null,
  otherFinancialInstrument: data.otherFinancialInstrument ?? null,
});
